import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const expansion = trigger('expansion', [
  state('collapsed, void', style({ height: '0px', visibility: 'hidden' })),
  state('expanded, enter', style({ height: '*', visibility: 'visible' })),
  transition('* <=> *', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
]);
